import { render } from "./VideoCarousel.vue?vue&type=template&id=8b871ad0&scoped=true"
import script from "./VideoCarousel.vue?vue&type=script&lang=js"
export * from "./VideoCarousel.vue?vue&type=script&lang=js"

import "./VideoCarousel.vue?vue&type=style&index=0&id=8b871ad0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b871ad0"]])

export default __exports__